module.exports = __webpack_public_path__ + "static/media/pexels-rodnae-productions-8581368.2b8c4d82.jpg";